import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-del-deatils",
  "use": "icon-del-deatils-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-del-deatils\">\n<rect y=\"0.5\" width=\"24\" height=\"24\" rx=\"12\" fill=\"#FFDBD3\" />\n<rect width=\"3\" height=\"15\" rx=\"1.5\" transform=\"matrix(-4.37114e-08 1 1 4.37114e-08 4.5 11)\" fill=\"#FA2256\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol